<template>
  <div>
    <div class="filter-container">
      <el-row :gutter="10">
        <el-col :md="4" :sm="6">
          <div>
            <el-input v-model="listQuery.report_id" :placeholder="$t('请输入检测报告编号')" clearable class="filter-item" @keyup.enter.native="handleFilter" />
          </div>
        </el-col>
        <el-col :md="4" :sm="6">
          <div>
            <el-input v-model="listQuery.machine_owner" :placeholder="$t('请输入所有者')" clearable class="filter-item" @keyup.enter.native="handleFilter" />
          </div>
        </el-col>
        <el-col :md="4" :sm="6">
          <div>
            <el-input v-model="listQuery.machine_owner_contact" :placeholder="$t('请输入联系电话')" clearable class="filter-item" @keyup.enter.native="handleFilter" />
          </div>
        </el-col>
        <el-col :md="4" :sm="6">
          <el-select v-model="listQuery.inspection_result" clearable placeholder="请选择" @keyup.enter.native="handleFilter">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-col>
        <el-button v-waves class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">
          {{ $t('admin.search_btn') }}
        </el-button>
        <el-button v-if="checkPermission(['larke-admin.verification.create'])" v-waves class="filter-item" type="primary" icon="el-icon-edit" @click="handleCreateOnRoad">
          {{ $t('verification.search_create') }}
        </el-button>
      </el-row>
    </div>

    <el-table
      ref="offTable"
      v-loading="loading"
      :data="list"
      border
      style="width: 100%"
      element-loading-text="拼命加载中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="report_id" label="报告编号" />
      <el-table-column prop="machine_owner" label="所有者" />
      <el-table-column prop="machine_owner_contact" label="联系电话" />
      <el-table-column prop="product_status" label="机械类型" />
      <el-table-column prop="model_specification" label="机械型号" />
      <el-table-column :label="$t('on_road.inspection_result')">
        <template slot-scope="scope">
          <el-tag v-if="!scope.row.inspection_result" type="info">未检测</el-tag>
          <el-tag v-else-if="scope.row.inspection_result === '合格'" type="success">{{ scope.row.inspection_result }}</el-tag>
          <el-tag v-else-if="scope.row.inspection_result === '不合格'" type="danger">{{ scope.row.inspection_result }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="admin.nickname" :label="$t('on_road.inspector')" />
      <el-table-column prop="test_time" label="检测日期" />
      <!--   当前状态    -->
      <el-table-column label="当前审批状态">
        <template slot-scope="scope">
          <el-tag v-if="!scope.row.stage" type="success" effect="dark">待检测</el-tag>
          <el-tag v-else-if="scope.row.stage === 1" type="success">已检测</el-tag>
          <el-tag v-else-if="scope.row.stage === 2" type="warning" effect="dark">待审核</el-tag>
          <el-tag v-else-if="scope.row.stage === 3" type="warning">已审核</el-tag>
          <el-tag v-else-if="scope.row.stage === 4" effect="dark">待批准</el-tag>
          <el-tag v-else-if="scope.row.stage === 5">已批准</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" :label="$t('on_road.created_at')" />
      <el-table-column align="left" :label="$t('admin.table_actions')" width="320">
        <template slot-scope="scope">
          <el-button
            v-if="checkPermission(['larke-admin.verification.update']) && (scope.row.stage === 0 || scope.row.stage === 1)"
            v-waves
            size="mini"
            type="primary"
            @click="handleEditOffRoad(scope.row)"
          >
            编辑
          </el-button>
          <el-button
            v-if="checkPermission(['larke-admin.verification.delete'])"
            v-waves
            size="mini"
            type="danger"
            @click="handleDelete(scope.row)"
          >
            删除
          </el-button>
          <!--   详情   -->
          <el-button
            v-if="checkPermission(['larke-admin.verification.check'])"
            v-waves
            size="mini"
            type="info"
            @click="handleDetail(scope.row)"
          >
            审核
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="handleTable"
    />

    <!-- 创建非道路车辆检验（测）报告  -->
    <el-dialog
      title="创建非道路车辆检验（测）报告"
      :visible.sync="offRoad.dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="1300px"
    >
      <create-off-road :item="offRoad" @success:add="handleAddOffRoadSuccess" />
    </el-dialog>

    <!-- 编辑非道路车辆检验（测）报告  -->
    <el-dialog
      title="编辑非道路车辆检验（测）报告"
      :visible.sync="editOffRoad.dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="1300px"
    >
      <edit-off-road :item="editOffRoad" @success:edit="handleEditOffRoadSuccess" />
    </el-dialog>

    <!-- 预览非道路车辆检验（测）报告  -->
    <el-dialog
      title="预览非道路车辆检验（测）报告"
      :visible.sync="previewOffRoad.dialogVisible"
    >
      <preview-off-road :item="previewOffRoad" @success:check="handleCheckOffRoadSuccess" />
    </el-dialog>
  </div>
</template>

<script>
import waves from '@/directive/waves' // waves directive
import checkPermission from '@/utils/permission' // 权限判断函数
import permission from '@/directive/permission'
import { listOffRoad, deleteOffRoad } from '@/api/verification'
import Pagination from '@/components/Pagination'
import CreateOffRoad from '@/views/verification/Components/CreateOffRoad.vue'
import EditOffRoad from '@/views/verification/Components/EditOffRoad.vue'
import PreviewOffRoad from '@/views/verification/Components/PreviewOffRoad.vue'
export default {
  name: 'OffRoad',
  components: { Pagination, CreateOffRoad, EditOffRoad, PreviewOffRoad },
  directives: { waves, permission },
  data() {
    return {
      list: [],
      options: [
        { value: '合格', label: '合格' },
        { value: '不合格', label: '不合格' }
      ],
      listQuery: {
        page: 1,
        limit: 20,
        report_id: '',
        machine_owner: '',
        machine_owner_contact: '',
        inspection_result: ''
      },
      total: 0,
      loading: false,
      offRoad: {
        dialogVisible: false
      },
      editOffRoad: {
        dialogVisible: false,
        id: 0
      },
      previewOffRoad: {
        dialogVisible: false,
        id: 0
      }
    }
  },
  methods: {
    handleTable() {
      this.loading = true
      listOffRoad(this.listQuery).then(response => {
        this.list = response.data.data
        this.total = response.data.total
      })
      this.loading = false
    },
    checkPermission,
    handleFilter() {
      this.handleTable()
    },
    handleCreateOnRoad() {
      this.offRoad.dialogVisible = true
    },
    handleEditOffRoad(row) {
      this.editOffRoad.dialogVisible = true
      this.editOffRoad.id = row.id
    },
    handleDelete(row) {
      this.$confirm('此操作将永久删除该条记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteOffRoad(row.id).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.handleTable()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleDetail(row) {
      this.previewOffRoad.dialogVisible = true
      this.previewOffRoad.id = row.id
    },
    handleAddOffRoadSuccess() {
      this.offRoad.dialogVisible = false
      this.handleTable()
    },
    handleEditOffRoadSuccess() {
      this.editOffRoad.dialogVisible = false
      this.handleTable()
    },
    handleCheckOffRoadSuccess() {
      this.previewOffRoad.dialogVisible = false
      this.handleTable()
    }
  }
}
</script>

<style scoped>

</style>
